import { CarIcon } from './types'
import Icons from '../Icons'

export { default as TransferSearchResultGroupListItem } from './TransferSearchResultGroupListItem'
export { default as TransferSearchResultListItem } from './TransferSearchResultListItem'
export { default as TransferSearchResultList } from './TransferSearchResultList'
export * from './types'

export function carIconToComponent(icon: CarIcon) {
  const icons = {
    shared: Icons.CarShared,
    economy: Icons.CarEconomy,
    hybrid: Icons.CarHybrid,
    electric: Icons.CarElectric,
    luxury: Icons.CarLuxury,
    unknown: Icons.CarEconomy,
  }

  return icons[icon] ?? Icons.CarEconomy
}
